import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Splash from '../views/Splash.vue';
import PageNotFound from '../views/PageNotFound.vue';
import About from '../views/About.vue';
import Geurs2020 from '../views/Geurs2020.vue';
import Contact from '../views/Contact.vue';
import FormDL1 from '../views/FormDL1.vue';
import FormDL2 from '../views/FormDL2.vue';
import ContactFindings from '../views/ContactFindings.vue';
import TheTeam from '../views/TheTeam.vue';
import Geurs2020Table from '../views/Geurs2020Table.vue';
import WorkingWithCompanies from '../views/WorkingWithCompanies.vue';
import StandardArticle from '../views/StandardArticle.vue';
import StandardPage from '../views/StandardPage.vue';
import Geurs2021 from '../views/Geurs2021.vue';
import Geurs2022 from '../views/Geurs2022.vue';
import store from '../store';
// import routes2021 from './routes2021';
import routes2022 from './routes2022';
import routes2023 from './routes2023';
import DL2023 from '../views/Dl2023.vue'; // splash page
import MiddlewareStylesheet from './middleware/style';

Vue.use(VueRouter);

const routes = [
  ...routes2022,
  ...routes2023,
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { layout: 'home' }
  },
  {
    path: '/countdown',
    name: 'Splash',
    component: Splash,
    meta: { layout: 'splash' }
  },
  {
    path: '/coming-soon',
    name: 'ComingSoon',
    component: DL2023,
    meta: { layout: 'splash', stylesheet: 'dl2023' }
  },
  //   { // Catchall
  //     path: '/:toto',
  //     name: 'Splash',
  //     component: Splash,
  //     meta: { layout: 'splash' }
  //   },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/contact',
    component: Contact
  },

  {
    path: '/digitalleaders/form1',
    component: FormDL1,
    meta: {
      variant: 'digitalleaders',
      formType: ''
    }
  },
  {
    path: '/digitalleaders/form2',
    component: FormDL2,
    meta: {
      variant: 'digitalleaders',
      formType: ''
    }
  },
  {
    path: '/digitalleaders/methodology',
    component: StandardPage,
    meta: {
      page: 'Digital-Leader-documents'
    }
  },
  {
    path: '/contact-findings',
    component: ContactFindings
  },
  {
    path: '/geurs2020',
    name: 'Geurs2020',
    component: Geurs2020
  },
  {
    path: '/qiuywe87163186372jasdkhjjd',
    name: 'Geurs2021',
    component: Geurs2021,
    meta: {
      layout: 'splash'
    }
  },
  {
    path: '/qiuywe87163186372jasdkhjjdqwe',
    name: 'Geurs2022',
    component: Geurs2022,
    meta: {
      layout: 'splash'
    }
  },
  {
    path: '/survey-2020-p1',
    component: Geurs2020
  },
  {
    path: '/geurs2020Table',
    name: 'Geurs2020Table',
    component: Geurs2020Table
  },
  {
    path: '/geurs-all-time',
    name: 'geurs-all-time',
    component: StandardPage,
    meta: {
      page:
        store.state.language.iso_code == 'fr'
          ? ''
          : '10-years-of-the-Global-Employability-University-Ranking'
    }
  },
  {
    path: '/indices',
    component: StandardArticle,
    meta: {
      articleId: store.state.language.iso_code == 'fr' ? '' : '5fa41a06462a02327ab8f6a6'
    }
  },

  {
    path: '/working-with-companies',
    name: 'working-with-companies',
    component: WorkingWithCompanies,
    meta: {
      page: store.state.language.iso_code == 'fr' ? '' : 'Working-with-companies'
    }
  },
  {
    path: '/Assistance-with-decision-making',
    name: 'Assistance-with-decision-making',
    component: StandardPage,
    meta: {
      page: store.state.language.iso_code == 'fr' ? '' : 'Assistance-with-decision-making'
    }
  },
  {
    path: '/Involvement-in-the-program',
    component: StandardPage,
    meta: {
      page: store.state.language.iso_code == 'fr' ? '' : 'Involvement-in-the-program'
    }
  },
  {
    path: '/Promoting-employer-branding',
    component: StandardPage,
    meta: {
      page: store.state.language.iso_code == 'fr' ? '' : 'Promoting-employer-branding'
    }
  }, // emerging-data
  {
    path: '/emerging-data',
    component: StandardPage,
    meta: {
      pageId: store.state.language.iso_code == 'fr' ? '' : '5fa1c3f07762b06ad3b1ad5b'
    }
  },
  {
    path: '/Integration',
    component: StandardPage,
    meta: {
      page: store.state.language.iso_code == 'fr' ? '' : 'Integration'
    }
  },
  {
    path: '/working-with-universities',
    component: StandardPage,
    meta: {
      page: store.state.language.iso_code == 'fr' ? '' : 'Working-with-Universities'
    }
  },
  {
    path: '/Promoting-Diversity',
    component: StandardPage,
    meta: {
      page: store.state.language.iso_code == 'fr' ? '' : 'Promoting-Diversity'
    }
  },
  {
    path: '/training-young-talent',
    component: StandardPage,
    meta: {
      page: store.state.language.iso_code == 'fr' ? '' : 'Training-young-talent'
    }
  },
  {
    path: '/heep',
    component: StandardArticle,
    meta: {
      article:
        store.state.language.iso_code == 'fr'
          ? ''
          : 'Measuring-and-improving-employability-performance'
    }
  },
  {
    path: '/nominees',
    component: StandardArticle,
    meta: {
      articleId:
        store.state.language.iso_code == 'fr'
          ? '60d494b47d664e65dfca7f7f'
          : '60d494b47d664e65dfca7f7f'
    }
  },
  {
    path: '/emerging-skills',
    component: StandardArticle,
    meta: {
      articleId:
        store.state.language.iso_code == 'fr'
          ? '5fb4d40f34941d755a466049'
          : '5fb4d47734941d755a46604a'
    }
  },
  {
    path: '/emergingGroup',
    component: StandardArticle,
    meta: {
      articleId: store.state.language.iso_code == 'fr' ? '' : '5fb505124939016cbf4a3304'
    }
  },
  {
    path: '/theTeam',
    component: TheTeam,
    meta: {
      pageId: store.state.language.iso_code == 'fr' ? '' : '5faaf6a8482f9f47ee8c7f1e'
    }
  },
  {
    path: '/Terms-and-Conditions',
    component: StandardPage,
    meta: {
      page: store.state.language.iso_code == 'fr' ? '' : 'Terms-and-Conditions'
    }
  },
  {
    path: '/Privacy-Policy',
    component: StandardPage,
    meta: {
      page: store.state.language.iso_code == 'fr' ? '' : 'Privacy-Policy'
    }
  },
  { path: '*', component: PageNotFound, meta: { layout: 'splash' } }
];

const router = new VueRouter({
  //   mode: 'history',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});
router.beforeEach(MiddlewareStylesheet);
export default router;
